export const SUPPORTS_ARRAY_PROTOTYPE_INCLUDES = "includes" in Array.prototype;
